import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=4d7a9097&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2044461438/src/tacotrade-platform/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4d7a9097')) {
      api.createRecord('4d7a9097', component.options)
    } else {
      api.reload('4d7a9097', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=4d7a9097&", function () {
      api.rerender('4d7a9097', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/settings/ChangePassword.vue"
export default component.exports